import { IconButton } from '@american-autonomy/ag-ui';

import ModalHeaderContainer from 'components/containers/ModalHeaderContainer';
import CloseIcon from 'components/icons/CloseIcon';
import TitleText from 'components/text/TitleText';

import { CLOSE_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceIntervalsModalHeader: FunctionComponent<Props> = ({
    className = '',
    onClose,
    testId = TEST_ID,
    title
}) => (
    <ModalHeaderContainer
        className={`${className} ${styles.serviceIntervalsModalHeader}`}
        testId={testId}>
        <TitleText className={styles.title} text={title} />

        <IconButton className={styles.closeButton} onClick={onClose} testId={CLOSE_BUTTON_TEST_ID}>
            <CloseIcon />
        </IconButton>
    </ModalHeaderContainer>
);

export default ServiceIntervalsModalHeader;
